import { cn } from "@gettactic/helpers";
import type React from "react";

interface GlobalSearchListItemLayoutProps {
  isActive: boolean;
  className?: string;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
  onKeyDown?: React.KeyboardEventHandler<HTMLDivElement>;
  children: React.ReactNode;
}

export function GlobalSearchListItemLayout({
  isActive,
  className,
  onClick,
  onKeyDown,
  children
}: GlobalSearchListItemLayoutProps) {
  return (
    <div
      onClick={onClick}
      onKeyDown={onKeyDown}
      className={cn(
        "group flex cursor-pointer items-center rounded-lg transition-colors",
        isActive ? "bg-neutral-100" : "hover:bg-neutral-50",
        className
      )}
    >
      {children}
    </div>
  );
}
